import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { CrudService } from "src/app/components/shared/cruds/crud.service";

@Injectable({ providedIn: "root" })
export class UnidadesService extends CrudService<any> {
  protected controller: string = "settings/unidades/";
  public getParaRecibir(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.serverUrl}api/${this.controller}get/recibir`
    );
  }

  public polizaAdd(IdUnidad: string, poliza: File): Observable<HttpEvent<any>> {
    const formData = new FormData();
    formData.append("IdUnidad", String(IdUnidad));
    if (poliza) {
      formData.append("poliza", poliza, "poliza");
    }

    const uploadReq = new HttpRequest(
      "POST",
      `${environment.serverUrl}api/settings/unidades/poliza/add`,
      formData
    );
    return this.http.request<any>(uploadReq);
  }

  public polizaDown(id: string): Observable<HttpResponse<Blob>> {
    return this.http.get(
      `${environment.serverUrl}api/settings/unidades/poliza/down`,
      { params: { id }, responseType: "blob", observe: "response" }
    );
  }
}
